
import { Link } from "react-router-dom";
import logo from './images/logo.png'
export const IpoHeader = () => {
  window.ipoLogin = JSON.parse(sessionStorage.getItem("ipoLogin"));

  return (<header className="navbar-light bg-light">
            <div className="container">
                <nav className="navbar navbar-expand-lg py-2">
                    <a className="navbar-brand" href="/" title="">
                        <img src={logo} alt="logo" className="w-75" />
                    </a>
                    <div className="collapse navbar-collapse" id="navbarSupportedContent">
                      <ul className="navbar-nav ml-auto">
                        <li className="nav-item">
                          <Link to='/' className="nav-link py-4">Home</Link>
                        </li>
                        { window.ipoLogin && window.ipoLogin &&
                          <li className="nav-item">
                            <Link to='/ipo-details' className="nav-link py-4">My Bids</Link>
                          </li>
                        }
                        { window.ipoLogin && window.ipoLogin &&
                          <li className="nav-item">
                            <a href='/' className="nav-link py-4" onClick={() => {window.ipoLogin = {};sessionStorage.removeItem('ipoLogin')}}>Logout</a>
                          </li>
                        }
                        </ul>
                      </div>
                </nav>
            </div>
        </header>)
}

export const IpoFooter = () => {
  return (<footer className="footer my-5">
            <div className="container text-center">
                <p className="footer-text">
                  In case of any assistance write to us on <strong>ipoteam@patelwealth.com</strong> or Call 
                  <strong> 8469184848</strong><br />
                  <a style={{color : "#888"}} href="https://www.npci.org.in/what-we-do/ipo/live-partners" target="_blank"><strong>Click here</strong></a> to check the list
                  of apps and banks which support UPI IPO currently.
                </p>
            </div>
     </footer>)
}